import React from 'react';
import {useMatch} from 'react-router-dom';
import {Button} from '@mui/material';
import translate from '@/utils/translate';
import {ROUTES} from '@/config/routesConstants';
import Link from '@/components/link';
import styles from './CampaignOpenBriefButton.module.scss';

function CampaignOpenBriefButton() {
  const match = useMatch(`${ROUTES.CAMPAIGNS_V2}/:campaignId/*`);

  if (!match || match.params['*'] === 'brief') {
    return null;
  }

  const briefUrl = `${ROUTES.CAMPAIGNS_V2}/${match.params.campaignId}/brief`;

  return (
    <Button
      component={Link}
      to={briefUrl}
      target="_blank"
      rel="noopener noreferrer"
      variant="outlined"
      size="small"
      className={styles.button}
    >
      {translate('Open Brief')}
    </Button>
  );
}

export default CampaignOpenBriefButton;
